/* ==========================================================================
   Prescriber credential helpers
   Shared between the provider's own profile form and the pharmacy's provider
   details page (PORTAL-74) so both label a credential type the same way.
   ========================================================================== */

import type { SelectOption } from '@/components/ui/Select'

export const CREDENTIAL_TYPES: SelectOption[] = [
  { value: 'md', label: 'MD - Doctor of Medicine' },
  { value: 'do', label: 'DO - Doctor of Osteopathic Medicine' },
  { value: 'np', label: 'NP - Nurse Practitioner' },
  { value: 'pa', label: 'PA - Physician Assistant' },
  { value: 'dds', label: 'DDS - Doctor of Dental Surgery' },
  { value: 'dmd', label: 'DMD - Doctor of Dental Medicine' },
  { value: 'dpm', label: 'DPM - Doctor of Podiatric Medicine' },
  { value: 'od', label: 'OD - Doctor of Optometry' },
  { value: 'dvm', label: 'DVM - Doctor of Veterinary Medicine' },
  { value: 'nd', label: 'ND - Naturopathic Doctor' },
  { value: 'nmd', label: 'NMD - Naturopathic Doctor' },
  { value: 'mb', label: 'MB - Bachelor of Medicine' },
  { value: 'other', label: 'Other' },
]

const CREDENTIAL_TYPES_REQUIRING_SUPERVISOR: readonly string[] = ['pa', 'np']

export function requiresSupervisingPhysician(ct: string | null): boolean {
  return ct !== null && CREDENTIAL_TYPES_REQUIRING_SUPERVISOR.includes(ct)
}

/** Full label for a credential type, e.g. "PA - Physician Assistant". */
export function credentialTypeLabel(ct: string | null): string | null {
  if (!ct) return null
  return CREDENTIAL_TYPES.find((o) => o.value === ct)?.label ?? ct.toUpperCase()
}
